import React from 'react';
import { Header } from '../abstractComponent/Header';
import { translator } from '../helpers/translator';

export default function Bandeau({ items, lang, search, setSearch }) {
return ( <div className="bandeau container">
  <div className="starter-template">
    <h1 className="title-bandeau">{translator('media_library', lang)}</h1>
    <div className="input-bandeau-container">
      <div className="input-group input-bandeau mb-3">
        <div className="input-group-prepend">
          <button className="btn btn-outline-secondary" type="button">
            <i className="fa fa-search" />
          </button>
        </div>
        <Header lang={lang} setSearch={setSearch} search={search}></Header>
      </div>
{search ? <div className="search-result">{`${translator("search_result_for", lang)} "${search}" : ${items.length} ${translator("results", lang)}`}</div> : null}
    </div>
  </div>
</div>)
}